// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"365":"35b5e5df","453":"9be5d679"}[chunkId] + ".chunk.js";
};